<template>
  <div
    class="input-input"
    >
    <label class="input-input__unit mt-2">
      <span class="input-input__label">Image {{ $t('control.panel.parameter') }}:</span>
      
      <input
        class="input-input__input"
        type="text"
        name="custom-parameter"
        v-model="currentLauncherImgSrc"
      >
    </label>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

export default {
  setup() {
    const launcherImgSrc = 'launcher-img-src';
    const store = useStore();
    const defaulttLauncherImgSrc = store.state.control.launcherImgSrc;

    const currentLauncherImgSrc = computed({
      get() {
          return store.state.control.launcherImgSrc;
      }, set(val){
          changeHandler({
            type: launcherImgSrc,
            value: val,
          })              
      }       
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      let handlerValue
  
      if(getRouterQueryValue(launcherImgSrc) === null){
        handlerValue = defaulttLauncherImgSrc
      } else {
        handlerValue = getRouterQueryValue(launcherImgSrc)
      }
      
      changeControlHandler({
        type: launcherImgSrc,
        value: handlerValue,
      });
    });

    return {
      currentLauncherImgSrc
    };
  },
}

</script>
